<template>
  <Main>
    <ToolsPanel
      :breadCrumbFirst="'Categories Groups'"
      :breadCrumbFirstLink="getFirstLink"
      :breadCrumbSecond="'Categories Group Create'"
      :title="'Categories Group Create'"
    >
      <div class="form-create__buttons">
        <MainButton buttonWhite @click.native="handleSubmit">Submit</MainButton>
        <MainButton @click.native="handleBackToList">Back</MainButton>
      </div>
    </ToolsPanel>
    <ContentContainer>
      <div class="form-create">
        <form @submit.prevent="handleSubmit">
          <p class="form-create__label">Name</p>
          <div class="input-container">
            <InputText
              :onChange="setName"
              :id="'name'"
              :label="'name'"
              :type="'text'"
              :value="formDataToSend.name"
              :placeholder="'Name'"
              :error-messages="validationErrors['name']"
              isBordered
            />
          </div>
          <p class="form-create__label">SEO Name</p>
          <div class="input-container">
            <InputText
              :onChange="setSeoName"
              :id="'seo_name'"
              :label="'seoName'"
              :value="formDataToSend.seo_name"
              :type="'text'"
              :placeholder="'SEO Name'"
              :error-messages="validationErrors['seoName']"
              isBordered
            />
          </div>

          <div class="input-container">
            <MainCheckbox :label="'Active'" :id="'status'" :set-value="formDataToSend" />
          </div>

          <p class="form-create__label">H1</p>
          <div class="input-container">
            <InputText
              :set-value="formDataToSend"
              :id="'h1'"
              :label="'h1'"
              :type="'text'"
              :placeholder="'H1'"
              :error-messages="validationErrors['h1']"
              isBordered
            />
          </div>

          <p class="form-create__label">Title</p>
          <div class="input-container">
            <InputText
              :set-value="formDataToSend"
              :id="'title'"
              :label="'title'"
              :type="'text'"
              :placeholder="'Title'"
              :error-messages="validationErrors['title']"
              isBordered
            />
          </div>

          <p class="form-create__label">Description</p>
          <div class="input-container">
            <InputText
              :set-value="formDataToSend"
              :id="'description'"
              :label="'description'"
              :type="'text'"
              :placeholder="'Description'"
              :max-length="'255'"
              :error-messages="validationErrors['description']"
              isBordered
            />
          </div>

          <p class="form-create__label">Annotation</p>
          <div class="input-container">
            <InputTextarea
              :set-value="formDataToSend"
              :id="'annotation'"
              :label="'annotation'"
              :placeholder="''"
              :error-messages="validationErrors['annotation']"
              isBordered
            />
          </div>

          <p class="form-create__label">SEO Text</p>
          <div class="input-container">
            <TextEditor
              :set-value="formDataToSend"
              :id="'seo_text'"
              :placeholder="''"
              :error-messages="validationErrors['seo_text']"
            />
          </div>

          <div class="form-create__radio-group">
            <div class="form-create__radio-group-item">
              <p class="form-create__label">Group Parent</p>
              <div class="input-container checkbox-container">
                <InputRadio
                  :set-value="formDataToSend"
                  :id="'parent'"
                  :values="categoriesGroupsTree"
                  :name="'name'"
                  :value="'id'"
                />
              </div>
            </div>
          </div>

          <p class="form-create__label">Attributes</p>
          <div class="form-create__chosen-items">
            <div
              v-for="(item, index) in formDataToSend.attributes"
              :key="index"
              class="form-create__chosen-item"
            >
              {{ item.name }} (seo: {{ item.seoName }})
              <span v-if="!item.parentId"><b>is parent</b></span>

              <div @click="deleteAttribute(index)" class="form-create__check-item-add">-</div>
            </div>
          </div>

          <input
            v-model="attributeSearch"
            class="form-create__search"
            type="text"
            placeholder="Search attribute..."
            @input="debouncedGetAttributes"
          />

          <div class="input-container checkbox-container checkbox-container_margin">
            <div v-for="(item, index) in attributesTree" :key="index">
              <div class="form-create__check-item">
                <b>{{ item.name }} (seo: {{ item.seoName }})</b>
                <div @click="addAttribute(item)" class="form-create__check-item-add">+</div>
              </div>
              <div v-if="item.children.length">
                <div
                  v-for="(el, i) in item.children[0]"
                  :key="i"
                  class="form-create__check-item child"
                >
                  {{ el.name }} (seo: {{ el.seoName }})
                  <div @click="addAttribute(el)" class="form-create__check-item-add">+</div>
                </div>
              </div>
            </div>
          </div>

          <p class="form-create__label">Categories</p>
          <div class="form-create__chosen-items">
            <div
              v-for="(item, index) in formDataToSend.categories"
              :key="index"
              class="form-create__chosen-item"
            >
              {{ item.fullName || item.name }}

              <div @click="deleteCategory(index)" class="form-create__check-item-add">-</div>
            </div>
          </div>

          <input
            v-model="categorySearch"
            class="form-create__search"
            type="text"
            placeholder="Search category..."
            @input="debouncedGetCategories"
          />

          <div class="input-container checkbox-container checkbox-container_margin">
            <div
              v-for="(item, index) in categoriesList"
              :key="index"
              class="form-create__check-item"
            >
              {{ item.fullName }}
              <div @click="addCategory(item)" class="form-create__check-item-add">+</div>
            </div>
          </div>
          <div v-if="error.message != undefined" class="form-create__error">
            {{ error.message }}
          </div>
          <div class="form-create__btn">
            <MainButton :type="'submit'">Submit</MainButton>
          </div>
        </form>
        <ModalError
          :error-modal="false"
          :handle-close-error-modal="
            () => {
              this.error = {};
            }
          "
        />
      </div>
    </ContentContainer>
    <FetchSpinnerModal v-if="loadingProcess" />
  </Main>
</template>

<script>
import { mapState } from "vuex";
import ROUTE from "~/constants/routes";
import { seoTransform } from "~/helpers/seoTransform";
import categoriesApi from "~/api/categories";
import { debounce } from "lodash";
import referencesApi from "~/api/references";

import Main from "~/templates/Main.vue";
import FetchSpinnerModal from "~/components/molecules/FetchSpinnerModal.vue";
import ToolsPanel from "~/components/molecules/ToolsPanel.vue";
import ContentContainer from "~/components/molecules/ContentContainer.vue";
import MainButton from "~/components/atoms/buttons/MainButton.vue";
import InputText from "~/components/atoms/inputs/InputText.vue";
import ModalError from "~/components/molecules/ModalError.vue";
import MainCheckbox from "~/components/atoms/inputs/MainCheckbox.vue";
import TextEditor from "~/components/atoms/inputs/TextEditor.vue";
import InputTextarea from "~/components/atoms/inputs/InputTextarea.vue";
import InputRadio from "~/components/atoms/inputs/InputRadio.vue";

export default {
  name: "CategoriesGroupCreate",
  metaInfo: {
    title: "Categories Group Create",
  },
  data() {
    return {
      formDataToSend: {
        name: "",
        seo_name: "",
        status: false,
        h1: "",
        title: "",
        description: "",
        annotation: "",
        seo_text: "",
        parent: null,
        categories: [],
        attributes: [],
      },
      categorySearch: "",
      attributeSearch: "",
      categoriesList: [],
      attributesTree: [],
    };
  },
  components: {
    Main,
    FetchSpinnerModal,
    ToolsPanel,
    ContentContainer,
    MainButton,
    InputText,
    ModalError,
    MainCheckbox,
    TextEditor,
    InputTextarea,
    InputRadio,
  },
  computed: {
    ...mapState("categories", [
      "error",
      "loadingProcess",
      "categoriesGroupsTree",
      "validationErrors",
    ]),
    getFirstLink() {
      return ROUTE.CATEGORIES_GROUPS_LIST.replace(":page", 1);
    },
  },
  mounted() {
    this.getCategoriesGroupsTree();
    this.getCategories();
    this.getAttributes();
  },
  methods: {
    handleSubmit() {
      const data = {
        name: this.formDataToSend.name != undefined ? this.formDataToSend.name.trim() : "",
        seo_name:
          this.formDataToSend.seo_name != undefined ? this.formDataToSend.seo_name.trim() : "",
        status: this.formDataToSend.status ? 1 : 0,
        h1: this.formDataToSend.h1 != undefined ? this.formDataToSend.h1.trim() : "",
        title: this.formDataToSend.title != undefined ? this.formDataToSend.title.trim() : "",
        description:
          this.formDataToSend.description != undefined
            ? this.formDataToSend.description.trim()
            : "",
        annotation:
          this.formDataToSend.annotation != undefined ? this.formDataToSend.annotation.trim() : "",
        seo_text:
          this.formDataToSend.seo_text != undefined ? this.formDataToSend.seo_text.trim() : "",
      };
      if (this.formDataToSend.parent) {
        data.parent_id = this.formDataToSend.parent;
      }

      data.categories = [];
      if (this.formDataToSend.categories.length) {
        this.formDataToSend.categories.forEach((item, index) => {
          data.categories.push(item.id);
        });
      }

      data.attributes = [];
      if (this.formDataToSend.attributes.length) {
        this.formDataToSend.attributes.forEach((item, index) => {
          data.attributes.push(item.id);
        });
      }

      this.$store.dispatch("categories/createCategoriesGroup", data);
    },
    getCategoriesGroupsTree() {
      this.$store.dispatch("categories/getCategoriesGroupsTree");
    },
    handleBackToList() {
      this.$router.push({
        path: ROUTE.CATEGORIES_GROUPS_LIST.replace(":page", 1),
      });
    },
    setName(value) {
      this.formDataToSend.name = value.trim();
      this.setSeoName(value);
    },
    setSeoName(data) {
      const value = seoTransform(data);
      this.formDataToSend.seo_name = value;
      this.handleCheckSeoName();
    },
    handleCheckSeoName() {
      if (this.formDataToSend.seo_name.length > 0) {
        const url = `/${this.formDataToSend.seo_name.trim()}`;
        this.$store.dispatch("categories/categoriesGroupCheckSeo", url);
      }
    },
    getCategories() {
      if (this.categorySearch.trim().length > 0) {
        const data = {
          search: this.categorySearch.trim(),
        };
        try {
          categoriesApi.getCategoriesListFilter("?status=1", data).then((res) => {
            const data = res.data.items.data;
            this.categoriesList = data;
          });
        } catch (error) {
          console.log(error);
        }
      } else {
        try {
          categoriesApi.getCategoriesActive().then((res) => {
            const data = res.data.items;
            this.categoriesList = data;
          });
        } catch (error) {
          console.log(error);
        }
      }
    },
    getAttributes() {
      let url = "";
      const search = this.attributeSearch.trim();
      if (search.length) {
        url = `?name=${search}`;
      }
      try {
        referencesApi.getTemplatesAttributesTree(url).then((res) => {
          this.attributesTree = res.data.items;
        });
      } catch (error) {
        console.log(error);
      }
    },
    debouncedGetCategories: debounce(function () {
      this.getCategories();
    }, 300),
    addCategory(item) {
      this.formDataToSend.categories.push(item);
    },
    deleteCategory(index) {
      this.formDataToSend.categories.splice(index, 1);
    },

    debouncedGetAttributes: debounce(function () {
      this.getAttributes();
    }, 300),
    addAttribute(item) {
      const exists = this.formDataToSend.attributes.some((a) => a.id === item.id);
      if (!exists) {
        this.formDataToSend.attributes.push(item);
      }
    },
    deleteAttribute(index) {
      this.formDataToSend.attributes.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.form-create {
  &__search {
    font-size: 18px;
    margin-top: 20px;
    width: 400px;
    padding: 5px 10px;
  }

  &__check-item {
    padding: 10px;
    display: flex;
    align-items: center;

    &.child {
      padding-left: 60px;
    }
  }

  &__check-item-add {
    margin-left: 20px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 5px;
    background: #3a80f9;
    border-radius: 50px;
    color: #fff;
    font-size: 18px;
    font-weight: 700;
  }

  &__chosen-items {
    display: flex;
    flex-wrap: wrap;
  }

  &__chosen-item {
    margin: 0 10px 10px 0;
    padding: 5px;
    background: gainsboro;
    border-radius: 10px;
    display: flex;
    align-items: center;
  }
}
</style>
